module.exports = {"action":"#void","passwordResetURL":"#void","registrationURL":"#void"}


//////////////////
// WEBPACK FOOTER
// ./src/widgets/sample/data.json
// module id = 107
// module chunks = 4